import { toastSuccess } from '../../ui/partials/Toast';

const copyToClipboard = (text = ''): void => {
  navigator.clipboard.writeText(text);

  toastSuccess('Copied to clipboard');
};

export default copyToClipboard;
